module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "recommend-account-opening-box"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountApply),
      expression: "accountApply"
    }],
    attrs: {
      "id": "accountApply"
    }
  }, [_c('div', {
    staticClass: "recommend-account-text"
  }, [_vm._v("赶紧输入信息，领取资格吧")]), _vm._v(" "), _c('div', {
    staticClass: "input-name"
  }, [_c('img', {
    staticClass: "input-img",
    attrs: {
      "src": require("./images/user.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientName),
      expression: "clientName"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "id": "clientName",
      "maxlength": "11",
      "placeholder": "请输入真实姓名"
    },
    domProps: {
      "value": (_vm.clientName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-name"
  }, [_c('img', {
    staticClass: "input-img",
    attrs: {
      "src": require("./images/phone.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tel),
      expression: "tel"
    }],
    attrs: {
      "type": "tel",
      "id": "mobile",
      "maxlength": "11",
      "name": "phone",
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tel = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-name"
  }, [_c('img', {
    staticClass: "input-img",
    attrs: {
      "src": require("./images/message.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifyCode),
      expression: "verifyCode"
    }],
    attrs: {
      "type": "tel",
      "name": "",
      "id": "verifyCode"
    },
    domProps: {
      "value": (_vm.verifyCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifyCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getYZM),
      expression: "getYZM"
    }],
    staticClass: "code-button",
    attrs: {
      "type": "button",
      "id": "getyzm"
    },
    on: {
      "click": _vm.getyzm
    }
  }, [_vm._v("获取验证码")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.getYZM),
      expression: "!getYZM"
    }],
    staticClass: "yzmbutton code-button",
    attrs: {
      "id": "cxhq"
    }
  }, [_vm._v("重新获取" + _vm._s(_vm.timeText) + "s")])]), _vm._v(" "), _c('div', {
    staticClass: "submit-text"
  }, [_vm._v("申请成功后，请留意查收开户操作指引短信,")]), _vm._v(" "), _c('div', {
    staticClass: "submit-text"
  }, [_vm._v("并下载东航期货App完成开户。")]), _vm._v(" "), _c('div', {
    staticClass: "submit"
  }, [_c('button', {
    staticClass: "submit-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.apply
    }
  }, [_vm._v("立即申请")])]), _vm._v(" "), _c('div', {
    staticClass: "submit-text mtb-10"
  }, [_vm._v("软件下载请点击下方按钮")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.accountApply),
      expression: "!accountApply"
    }],
    attrs: {
      "id": "accountApplyShow"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "success-text"
  }, [_vm._v("您已领取成功")]), _vm._v(" "), _c('div', {
    staticClass: "apply-text"
  }, [_vm._v("请下载并使用东航期货APP完成开户")])]), _vm._v(" "), _c('div', {
    staticClass: "dowload-phone-icon"
  }, [_c('a', {
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": _vm.Download
    }
  }, [_c('img', {
    staticClass: "phone-icon-img phone-icon-img-android",
    attrs: {
      "src": require("./images/android.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": _vm.Download
    }
  }, [_c('img', {
    staticClass: "phone-icon-img phone-icon-img-ios",
    attrs: {
      "src": require("./images/ios.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "website"
  }, [_vm._v("从事证券投资或期货交易，请通过合法证券期货经营机构进行。合法机构名单可到中国证监会网站（www.csrc.gov.cn）查询。")]), _vm._v(" "), _c('div', {
    staticClass: "website"
  }, [_vm._v("——投资有风险 入市需谨慎——")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "website"
  }, [_vm._v("本活动最终解释权仅归东航期货所有")]), _vm._v(" "), _c('div', {
    staticClass: "website jinhao"
  }, [_vm._v("沪ICP备14006107号-1 沪公网安备31011202001150号")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toastShow),
      expression: "toastShow"
    }],
    attrs: {
      "id": "toast"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.toastText) + "\n    ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "compnay-default-icon",
    attrs: {
      "alt": "",
      "src": require("./images/logo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compnay-text-icon-box"
  }, [_c('img', {
    staticClass: "compnay-text-icon",
    attrs: {
      "alt": "",
      "src": require("./images/tittle.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success-icon-box"
  }, [_c('img', {
    staticClass: "success-icon",
    attrs: {
      "src": require("./images/success.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "extra-welfare"
  }, [_c('div', {
    staticClass: "extra-welfare-box"
  }, [_c('div', {
    staticClass: "welfare-title"
  }, [_c('span', {
    staticClass: "icon"
  }), _c('span', [_vm._v("免费期货靓号")])]), _vm._v(" "), _c('div', {
    staticClass: "welfare-context"
  }, [_c('span', {
    staticClass: "yellow-icon"
  }), _vm._v(" "), _c('span', [_vm._v("如尾号「666」、「888」等期货靓号，数量有限，先到先得!")]), _vm._v(" "), _c('div', {
    staticClass: "special-text"
  }, [_vm._v("(温馨提示:请在提交资料后7日内完成开户哦)")])]), _vm._v(" "), _c('div', {
    staticClass: "welfare-title welfare-title-jifen"
  }, [_c('span', {
    staticClass: "icon"
  }), _c('span', [_vm._v(" 乐享积分换好礼")])]), _vm._v(" "), _c('div', {
    staticClass: "welfare-context"
  }, [_c('span', {
    staticClass: "yellow-icon"
  }), _vm._v(" "), _c('span', [_vm._v("参与APP内活动即有机会赢取积分奖励。更有机票、话费等各类积分好礼送不停！")])])]), _vm._v(" "), _c('div', {
    staticClass: "extra-welfare-box extra-welfare-jifen-box"
  }, [_c('div', {
    staticClass: "company-introduce"
  }, [_c('div', {
    staticClass: "compnay-img"
  }, [_c('img', {
    staticClass: "company-icon",
    attrs: {
      "alt": "",
      "src": require("./images/kiiik.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "company-text"
  }, [_vm._v("东航期货，成立于1995年，总部设于上海，是中国东方航空集团有限公司下属东航金控有限责任公司的全资子公司。\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "company-introduce"
  }, [_c('div', {
    staticClass: "compnay-img"
  }, [_c('img', {
    staticClass: "company-icon",
    attrs: {
      "alt": "",
      "src": require("./images/lhmj.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "company-text"
  }, [_vm._v("公司是上世纪首批由中国证监会核准成立的期货公司之一，国内知名期货实盘大赛“蓝海密剑”主办方。\n              ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "website"
  }, [_c('img', {
    staticClass: "ending-logo",
    attrs: {
      "src": require("./images/logo.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cdda1c8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/qhRecommendOpenAccount/index.vue
// module id = 912
// module chunks = 2